<div class="main">
  <!-- <bi-column-customizer (columnsCustomizationChanged)="OnColumnCustomizationChanged($event)" (hideMeEmitter)="ToggleColumnCustomizerVisibility()" *ngIf="isCustomizeColumnsVisible" [columns]="Columns"></bi-column-customizer> -->
  <span (click)="ShowDialog(DomID)" class="custom-grid"><svg width="17px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18.48 18.5368H21M4.68 12L3 12.044M4.68 12C4.68 13.3255 5.75451 14.4 7.08 14.4C8.40548 14.4 9.48 13.3255 9.48 12C9.48 10.6745 8.40548 9.6 7.08 9.6C5.75451 9.6 4.68 10.6745 4.68 12ZM10.169 12.0441H21M12.801 5.55124L3 5.55124M21 5.55124H18.48M3 18.5368H12.801M17.88 18.6C17.88 19.9255 16.8055 21 15.48 21C14.1545 21 13.08 19.9255 13.08 18.6C13.08 17.2745 14.1545 16.2 15.48 16.2C16.8055 16.2 17.88 17.2745 17.88 18.6ZM17.88 5.4C17.88 6.72548 16.8055 7.8 15.48 7.8C14.1545 7.8 13.08 6.72548 13.08 5.4C13.08 4.07452 14.1545 3 15.48 3C16.8055 3 17.88 4.07452 17.88 5.4Z" stroke="#000" stroke-width="1.5" stroke-linecap="round"/>
    </svg></span>
  <kendo-grid [sort]="DataService.state.sort" [height]="height ? height : 350" [dir]="biService.getDir() ? 'rtl': 'ltr'"
    #Grid [filterable]="'menu'" [data]="GridData | async" [sortable]="true" [resizable]="true" [selectable]="true"
    kendoGridSelectBy [(selectedKeys)]="mySelection" (cellClick)="cellClickHandler($event)" [filter]="Kendofilter"
    (dataStateChange)="onValueChange($event)" (cellClose)="cellCloseHandler($event)"
    (filterChange)="filterChange($event)">
    <!-- Your column definitions here -->

    <ng-template kendoGridNoRecordsTemplate>
      {{'NoRecordsAvailable' | translate}}
    </ng-template>
    
    <ng-container *ngFor="let res of Columns" [ngSwitch]="res.controlType">
      <kendo-grid-column [filterable]="res.IsFilterable" [sortable]="res.IsFilterable" [hidden]="!res.IsVisible"
        *ngSwitchCase="'text'" [filter]="res.DataType" [field]="res.Name" [title]="res.DisplayName | translate"
        [width]="res.Width ? res.Width: 140">
        <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-formGroup="formGroup">
          <kendo-textbox [formControl]="formGroup.controls[res.Name]" [value]="formGroup.getRawValue()[res.Name]"
            (change)="bindingData($event, res.Name)"></kendo-textbox>
          <span *ngIf="formGroup.controls[res.Name].invalid">
            <span class="text-danger" *ngIf="formGroup.controls[res.Name].errors?.required">
              {{res.DisplayName | translate}} {{'IsRequired' | translate}}
            </span>
            <span class="text-danger" *ngIf="formGroup.controls[res.Name].errors?.email">
              {{'Emailaddressisinvalid' | translate}}
            </span>
            <span class="text-danger"
              *ngIf="formGroup.controls[res.Name].errors?.noWhiteSpace&&(!formGroup.controls[res.Name].errors?.pattern)">
              {{res.DisplayName | translate}} {{'cantBeEmpty' | translate}}
            </span>
            <span class="text-danger" *ngIf="formGroup.controls[res.Name].errors?.maxlength">
              {{res.DisplayName | translate}} {{'maxValueIs'|translate}}
              {{formGroup.controls[res.Name].errors?.maxlength?.requiredLength}}
            </span>
            <span class="text-danger" *ngIf="formGroup.controls[res.Name].errors?.pattern">
              {{res.DisplayName | translate}} {{'inputIsNotInACorrectFormat' | translate}}
            </span>
          </span>
        </ng-template>
        <ng-template kendoGridCellTemplate let-dataItem>
          <span [ngStyle]="res.ConditionalCellStyleFn ? res.ConditionalCellStyleFn(dataItem) : ''">
            {{ dataItem | getValue : res.Name }}
          </span>
        </ng-template>
      </kendo-grid-column>

    <kendo-grid-column [filterable]="res.IsFilterable" [sortable]="res.IsFilterable" [hidden]="!res.IsVisible"
      *ngSwitchCase="'numeric'" [filter]="res.DataType" [field]="res.Name" [title]="res.DisplayName | translate"
      [width]="res.Width ? res.Width: 140">
      <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-formGroup="formGroup">
        <input [formControl]="formGroup.controls[res.Name]" type="number" class="form-control"
          (change)="bindingData($event, res.Name)" [value]="formGroup.getRawValue()[res.Name]">
        <span class="text-danger" *ngIf="formGroup.controls[res.Name].errors?.required">
          {{res.DisplayName | translate}} {{'IsRequired' | translate}}
        </span>
        <span class="text-danger" *ngIf="formGroup.controls[res.Name].errors?.min">
          {{res.DisplayName | translate}} {{'minValueIs'|translate}}
          {{formGroup.controls[res.Name].errors?.min?.min}}
        </span>
        <span class="text-danger" *ngIf="formGroup.controls[res.Name].errors?.max">
          {{res.DisplayName | translate}} {{'maxValueIs'|translate}}
          {{formGroup.controls[res.Name].errors?.max?.max}}
      </span>
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem>
        <span [ngStyle]="res.ConditionalCellStyleFn ? res.ConditionalCellStyleFn(dataItem) : ''">
            <ng-container *ngIf="res?.removeNegativeTransform; else showNegativeValueTransform;">
                {{
                res?.Precision?
               ( res?.Precision===0?(dataItem | getValue : res.Name) :(dataItem | getValue : res.Name |
                number: res.Precision? '1.' + res.Precision + '-' + res.Precision : DefaultPrecision)):
                (dataItem | getValue : res.Name)
                }}
            </ng-container>

            <ng-template #showNegativeValueTransform>
                {{
                res?.Precision?
               ( res?.Precision===0?(dataItem | getValue : res.Name) :(dataItem | getValue : res.Name | number:  res.Precision? '1.' + res.Precision + '-' + res.Precision  : DefaultPrecision | negativeValueTransform)):
                (dataItem | getValue : res.Name) }}
            </ng-template>
        </span>
    </ng-template>
    </kendo-grid-column>

      <kendo-grid-column [filterable]="res.IsFilterable" [sortable]="res.IsFilterable" [hidden]="!res.IsVisible"
        *ngSwitchCase="'time'" [filter]="res.DataType" [field]="res.Name" [title]="res.DisplayName | translate"
        [width]="res.Width ? res.Width: 140">
        <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-formGroup="formGroup">
          <kendo-timepicker [formControl]="formGroup.controls[res.Name]" [id]="'input_'+res?.DomID"></kendo-timepicker>
          <span class="text-danger" *ngIf="formGroup.controls[res.Name].errors?.required">
            {{res.DisplayName | translate}} {{'IsRequired' | translate}}
          </span>
        </ng-template>
        <ng-template kendoGridCellTemplate let-dataItem>
          {{ dataItem | getValue : res.Name}}
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column [filterable]="res.IsFilterable" [sortable]="res.IsFilterable" [hidden]="!res.IsVisible"
        *ngSwitchCase="'date'" [filter]="res.DataType" [field]="res.Name" [title]="res.DisplayName | translate"
        [width]="res.Width ? res.Width: 140">
        <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-formGroup="formGroup">
          <kendo-datepicker [formControl]="formGroup.controls[res.Name]" [value]="formGroup.getRawValue()[res.Name]"
            (valueChange)="bindingData($event, res.Name)" calendarType="classic"></kendo-datepicker>
          <span class="text-danger" *ngIf="formGroup.controls[res.Name].errors?.required">
            {{res.DisplayName | translate}} {{'IsRequired' | translate}}
          </span>
        </ng-template>
        <ng-template kendoGridCellTemplate let-dataItem>
          {{(dataItem | getValue : res.Name) | date: "medium"}}

        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column [filterable]="res.IsFilterable" [sortable]="res.IsFilterable" *ngSwitchCase="'boolean'"
        [filter]="res.DataType" [hidden]="!res.IsVisible" [field]="res.Name" [title]="res.DisplayName | translate"
        [width]="res.Width ? res.Width: 140">
        <ng-template kendoGridHeaderTemplate *ngIf="HasSelectAll || res?.checkboxTemplate?.HasSelectAll">
          <input type="checkbox" [(ngModel)]="selectAll" (change)="changeCheckAll($event, res.Name)">
          <span *ngIf=" res?.checkboxTemplate?.HasSelectAllLabel">
            {{'SelectAll' | translate}}
          </span>
        </ng-template>
        <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-formGroup="formGroup" let-rowIndex="rowIndex"
          *ngIf="res?.checkboxTemplate?.HasSelectAll">
          <input type="checkbox" (change)="changeCheckBox($event, res.Name, dataItem, rowIndex)"
            [checked]="dataItem[res.Name] || selectAll"
            [disabled]="!res.IsEditable||(IsDisabledCellTemplate(dataItem[this.RowIdentifier],res.Name)) " />
          <!-- <input type="checkbox" [checked]="dataItem[res.Name] || selectAll" [formControl]="formGroup.controls[res.Name]"
          [value]="formGroup.getRawValue()[res.Name]"/> -->
        </ng-template>
        <ng-template kendoGridCellTemplate let-dataItem *ngIf="res?.checkboxTemplate?.HasSelectAll"
          let-rowIndex="rowIndex">
          <input type="checkbox" (change)="changeCheckBox($event, res.Name, dataItem, rowIndex)"
            [checked]="dataItem[res.Name] || selectAll"
            [disabled]="!res.IsEditable||(IsDisabledCellTemplate(dataItem[this.RowIdentifier],res.Name)) " />
        </ng-template>

        <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-formGroup="formGroup" let-rowIndex="rowIndex"
          *ngIf="!res?.checkboxTemplate?.HasSelectAll">
          <input type="checkbox" [checked]="dataItem[res.Name]" [formControl]="formGroup.controls[res.Name]"
            [value]="formGroup.getRawValue()[res.Name]" />
        </ng-template>
        <ng-template kendoGridCellTemplate let-dataItem *ngIf="!res?.checkboxTemplate?.HasSelectAll"
          let-rowIndex="rowIndex">
          <input type="checkbox" (change)="changeCheckBox($event, res.Name, dataItem, rowIndex)"
            [checked]="dataItem[res.Name]" [disabled]="!res.IsEditable" />
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column [filterable]="res.IsFilterable" [sortable]="res.IsFilterable" [hidden]="!res.IsVisible"
        *ngSwitchCase="'select'" [filter]="res.DataType" [field]="res.Name" [title]="res.DisplayName | translate"
        [width]="res.Width ? res.Width: 140">
        <ng-template kendoGridFilterMenuTemplate let-filter let-column="column" let-filterService="filterService">
          <kendo-dropdownlist [data]="res?.dropDownTemplate?.list" [textField]="'' + res?.dropDownTemplate?.text"
            [valueField]="''+res?.dropDownTemplate?.value"
            (valueChange)="filterByDropList($event, filterService, res.Name)" [valuePrimitive]="true">
          </kendo-dropdownlist>
        </ng-template>
        <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-formGroup="formGroup">
          <bi-dropDown [Name]="res.Name" [DropDownList]="res?.dropDownTemplate?.list"
            [BindingProperty]="formGroup.controls[res.Name]" [ValueField]="res?.dropDownTemplate?.value"
            [TextField]="res?.dropDownTemplate?.text"
            (OnValueChange)="res?.dropDownTemplate?.OnValueChange && res?.dropDownTemplate?.OnValueChange($event)"
            (OnFocus)="res?.dropDownTemplate?.OnFocus()" (OnOpen)="res?.dropDownTemplate?.OnOpen()"></bi-dropDown>

          <span class="text-danger" *ngIf="formGroup.controls[res.Name].errors?.required">
            {{res.DisplayName | translate}} {{'IsRequired' | translate}}
          </span>
        </ng-template>
        <ng-template kendoGridCellTemplate let-dataItem>
          <span [colorStatus]="{key: dataItem[res.Name], colors}">
            {{ GetDropDownTxtValueByCode(dataItem | getValue : res.Name, res?.dropDownTemplate) }}
          </span>
        </ng-template>
      </kendo-grid-column>


      <kendo-grid-column [filterable]="res.IsFilterable" [sortable]="res.IsFilterable" [hidden]="!res.IsVisible"
        *ngSwitchCase="'lookup'" [filter]="res.DataType" [field]="res.Name" [title]="res.DisplayName | translate"
        [width]="res.Width ? res.Width: 140">
        <ng-template kendoGridEditTemplate let-formGroup="formGroup">
          <app-bi-lookup [BindingProperty]="formGroup.controls[res.Name]"
            [DataSource]="res.lookupTemplate?.['DataSource']" [Key]="res.lookupTemplate?.['Key']"
            [Title]="res.DisplayName" [DomID]="res.lookupTemplate?.['ID']" [DataType]="res.DataType"
            [hasSecondLkp]="res.lookupTemplate?.['hasSecondLkp'] ? true : false"
            (AfterLoad)="res.lookupTemplate?.AfterLoad && res.lookupTemplate?.AfterLoad()"
            (BeforeLoad)="res.lookupTemplate?.BeforeLoad && res.lookupTemplate?.BeforeLoad()"
            (OnClose)="res.lookupTemplate?.OnClose && res.lookupTemplate?.OnClose()"
            (OnOpen)="res.lookupTemplate?.OnOpen && res.lookupTemplate?.OnOpen()"
            (OnOpenSecondLkp)="res.lookupTemplate?.OnOpenSecondLkp && res.lookupTemplate?.OnOpenSecondLkp()"
            (ReturnedValueEmitter)="res.lookupTemplate?.ReturnedValueEmitter&&res.lookupTemplate?.ReturnedValueEmitter($event)"
            [Description]="res.lookupTemplate?.['Description'] ? res.lookupTemplate?.Description : ''"
            [setPreventCloseRow]="setPreventCloseRow" [classNameSelector]="'padding-button-reset btn btn-light'"
            [route]="res.lookupTemplate?.route" [hasPendingChanges]="CheckPendingChange()"
            [hasSelection]="res.lookupTemplate?.hasSelection">
          </app-bi-lookup>
          <!-- (ErrorStateEmitter)="GetLookupErrorState($event, res.Name)"> -->

          <span class="text-danger" *ngIf="formGroup.controls[res.Name].errors?.required">
            {{res.DisplayName | translate}} {{'IsRequired' | translate}}
          </span>
        </ng-template>

       <ng-template kendoGridCellTemplate let-dataItem *ngIf="res.lookupTemplate?.route">
                    <div>
                        <a href="javascript:void(0)" (click)="goToPage(res.lookupTemplate?.route,dataItem[res.Name])"
                            class="hyperlink">
                            {{ dataItem | getValue : res.Name}}</a>
                    </div>
        </ng-template>
       <ng-template kendoGridCellTemplate let-dataItem *ngIf="!res.lookupTemplate?.route">
          {{ dataItem | getValue : res.Name }}
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column [filterable]="res.IsFilterable" [sortable]="res.IsFilterable" [hidden]="!res.IsVisible"
      *ngSwitchCase="'Image'" [filter]="res.DataType" [field]="res.Name"
      [title]="res.DisplayName | translate" [width]="res.Width ? res.Width: 140">
      <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-formGroup="formGroup">
        <img class="img-style" [src]="formGroup.getRawValue()[res.Name]" alt="">
      </ng-template>
        <ng-template kendoGridCellTemplate let-dataItem>
        <img class="img-style"  [src]="dataItem | getValue : res.Name " alt="">
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column [filterable]="res.IsFilterable" [sortable]="res.IsFilterable" [hidden]="!res.IsVisible"
      *ngSwitchCase="'LogImage'" [filter]="res.DataType" [field]="res.Name"
      [title]="res.DisplayName | translate" [width]="res.Width ? res.Width: 140">
      <ng-template kendoGridCellTemplate let-dataItem>
          <ng-container *ngFor="let img of res.imgs">
              <img [src]="img.image" alt=""
                  *ngIf="(dataItem | getValue : res.Name)==img.showOnValue">
          </ng-container>
      </ng-template>
      <ng-template kendoGridEditTemplate  let-dataItem="dataItem" let-formGroup="formGroup">
          <ng-container *ngFor="let img of res.imgs">
              <img [src]="img.image" alt=""
                  *ngIf="formGroup.getRawValue()[res.Name]==img.showOnValue">
          </ng-container>
      </ng-template>
  </kendo-grid-column>
    </ng-container>
  </kendo-grid>
  <kendo-datapager *ngIf="HasPaging!=false" [dir]="biService.getDir() ? 'rtl': 'ltr'" class="mb-0 font-weight-bold "
    [total]="totalDataLength" [pageSize]="DataService.state.take ? DataService.state.take : 0"
    [skip]="DataService.state.skip ? DataService.state.skip : 0" (pageChange)="onPageChange($event)">
    <kendo-datapager-messages page="{{'page' | translate}}" of="{{'of' | translate}}"
      items="{{'vu_StockCheck' | translate}}"
      itemsPerPage="{{'items Per Page' | translate}}"></kendo-datapager-messages>
  </kendo-datapager>
</div>
